import { render, staticRenderFns } from "./SavingsAccountDeclineModal.vue?vue&type=template&id=68beffda"
import script from "./SavingsAccountDeclineModal.vue?vue&type=script&lang=js"
export * from "./SavingsAccountDeclineModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports